import { cn } from '@distribute/frontend/utils';
import { FC, ReactNode } from 'react';

import { TimeAgo } from '../../../shared/ui';

import { VideoCardFailed } from './VideoCardFailed';
import { VideoCardLoading } from './VideoCardLoading';

import { UNTITLED_VIDEO_NAME } from './config';

type Props = {
  onClick: () => void;

  Owner?: ReactNode;
  PermissionStatus?: ReactNode;
  createdAt: Date;
  title: string;
  duration: string;
  className?: string;
  Action?: ReactNode;
  url: string;
  isFailed?: boolean;
  isLoading?: boolean;
};

export const VideoCardPreview: FC<Props> = ({
  Action,
  title,
  createdAt,
  duration,
  PermissionStatus,
  Owner,
  isFailed,
  isLoading,
  url,
  onClick,
}) => {
  return (
    <div
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => e.key === 'Enter' && onClick()}
      className={cn(
        'w-full p-3 border border-gray-300 rounded-xl relative',
        'flex flex-col gap-y-4 cursor-pointer group hover:shadow-sm'
      )}
    >
      <div
        className={cn(
          'relative overflow-hidden rounded-lg border border-base-black/[0.08] h-41 flex-shrink-0'
        )}
      >
        <div
          className="absolute top-2 right-2 invisible group-hover:visible"
          onClick={(e) => e.stopPropagation()}
        >
          {Action}
        </div>
        <div
          className={cn(
            'bg-gray-900/[0.75] backdrop-blur-[10px] rounded-2xl text-sm text-base-white font-medium',
            'px-2.5 py-0.5',
            'absolute bottom-2 right-2',
            { hidden: isFailed || isLoading }
          )}
        >
          {duration}
        </div>

        {isFailed ? (
          <VideoCardFailed size="sm" />
        ) : isLoading ? (
          <VideoCardLoading size="sm" />
        ) : (
          <img
            src={url}
            alt="poster"
            className="object-cover w-full h-full block bg-gray-100"
          />
        )}
      </div>
      <div className="flex flex-col gap-y-1.5">
        {Owner}
        <p className="text-md text-gray-900 font-semibold truncate">
          {title || UNTITLED_VIDEO_NAME}
        </p>
        <div className="flex flex-nowrap gap-x-1 items-center justify-between">
          <p className="text-sm text-gray-600 flex-shrink-0">
            <TimeAgo datetime={createdAt} locale="my" />
          </p>
          {PermissionStatus}
        </div>
      </div>
    </div>
  );
};
